type TScoringInput = {
    has_provided_conveyancer_details: boolean;
    conveyancer_confirmed_timeframe: boolean;
    selling_property_state: string;
    has_provided_proof_of_funds: boolean;
    payment_method: string;
    mortgage_broker_has_vouched: boolean;
    has_provided_mortgage_broker_details: boolean;
};

const sellingPropertyStateSpeedPoints = (state: string): number => {
    switch (state) {
        case "no_property_to_sell":
            return 2;
        case "property_to_sell_already_exchanged":
            return 1;
        case "property_to_sell_sold_stc":
        case "property_to_sell_under_offer":
            return 0;
        case "property_to_sell_on_the_market":
            return -1;
        case "property_to_sell_not_on_the_market":
            return -2;
        case "property_to_let":
            return -1;
        default:
            return -2;
    }
};

const sellingPropertyStateRiskPoints = (state: string): number => {
    switch (state) {
        case "no_property_to_sell":
            return 2;
        case "property_to_sell_already_exchanged":
            return 1;
        case "property_to_sell_sold_stc":
        case "property_to_sell_under_offer":
            return 0;
        case "property_to_sell_on_the_market":
            return -1;
        case "property_to_sell_not_on_the_market":
            return -2;
        case "property_to_let":
            return -1;
        default:
            return -2;
    }
};

const paymentMethodSpeedPoints = (method: string): number => {
    switch (method) {
        case "cash":
            return 2;
        case "mortgage":
            return 0;
        case "bridging_loan":
            return 1;
        default:
            return -1;
    }
};

const paymentMethodRiskPoints = (method: string): number => {
    switch (method) {
        case "cash":
            return 2;
        case "mortgage":
            return 0;
        case "bridging_loan":
            return 0;
        default:
            return -1;
    }
};

export const calculateSpeedPoints = (input: TScoringInput): number =>
    (input.has_provided_conveyancer_details ? 1 : 0)
    + (input.conveyancer_confirmed_timeframe ? 2 : 0)
    + sellingPropertyStateSpeedPoints(input.selling_property_state)
    + (input.has_provided_proof_of_funds ? 1 : 0)
    + paymentMethodSpeedPoints(input.payment_method)
    + (input.mortgage_broker_has_vouched ? 1 : 0);

export const calculateRiskPoints = (input: TScoringInput): number =>
    (input.has_provided_conveyancer_details ? 1 : 0)
    + (input.conveyancer_confirmed_timeframe ? 1 : 0)
    + sellingPropertyStateRiskPoints(input.selling_property_state)
    + (input.has_provided_proof_of_funds ? 2 : 0)
    + paymentMethodRiskPoints(input.payment_method)
    + (input.mortgage_broker_has_vouched ? 2 : 0)
    + (input.has_provided_mortgage_broker_details ? 1 : 0);

export const speedFromPoints = (points: number): "fast" | "medium" | "slow" =>
    points >= 5
        ? "fast"
        : points >= 2
            ? "medium"
            : "slow";

export const riskFromPoints = (points: number): "low" | "medium" | "high" =>
    points >= 6
        ? "low"
        : points >= 2
            ? "medium"
            : "high";
